"use strict";

jQuery(document).ready(function ($) {
  // Hamburger menu
  $('.hamburger').on('click', function () {
    $(this).toggleClass('is-active');
    $('.main-menu').slideToggle('slow');
  }); // Search bar menu

  $('.header__search').on('click', function () {
    $(this).toggleClass('is-active');
    $('.main-search').slideToggle('medium');
  }); // Latest news carousel

  $('.latest-news').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    prevArrow: '<span class="latest-news__arrow latest-news__arrow--prev"></span>',
    nextArrow: '<span class="latest-news__arrow latest-news__arrow--next"></span>',
    speed: 400,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  if ($('.rcb_slider__slider').length) {
    // Latest news carousel
    $('.rcb_slider__slider').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: true,
      prevArrow: '<span class="rcb_slider__arrow rcb_slider__arrow--prev"></span>',
      nextArrow: '<span class="rcb_slider__arrow rcb_slider__arrow--next"></span>',
      speed: 400,
      pauseOnHover: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }]
    });
  }

  if ($('.logo-strip__slider').length) {
    // Latest news carousel
    $('.logo-strip__slider').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: true,
      prevArrow: '<span class="logo-strip__slider--arrow logo-strip__slider--arrow--prev"></span>',
      nextArrow: '<span class="logo-strip__slider--arrow logo-strip__slider--arrow--next"></span>',
      speed: 400,
      pauseOnHover: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1130,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 860,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      }]
    });
  } // Homepage boxes


  $('.home-nav-link').on('click', function () {
    var box = $(this).attr('data-link-src');
    var link = $('#' + box + ' option:selected').val();
    window.location.href = link;
  });
  $('.toggle-scroll').on('click', function () {
    var dataTarget = $(this).attr('data-target');

    if (dataTarget !== "#faux-top") {
      $('.resources__section').each(function () {
        $(this).removeClass('active');
      });
      $(dataTarget).addClass('active');
    }

    $('html, body').animate({
      scrollTop: $(dataTarget).offset().top - 40
    }, 500);
  }); // jQquery accordion

  $('.accordion__container').accordion({
    collapsible: true,
    heightStyle: 'content',
    active: false
  }); // Gallery carousel

  $('.gallery__carousel').slick({
    autoplay: false,
    arrows: true,
    prevArrow: '<span class="gallery__arrow gallery__arrow--prev"></span>',
    nextArrow: '<span class="gallery__arrow gallery__arrow--next"></span>',
    speed: 400,
    slidesToShow: 4,
    responsive: [{
      breakpoint: 900,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }]
  }); // Lightbox option

  lightbox.option({
    'resizeDuration': 400,
    'wrapAround': true
  }); // General contact form

  if ($('.contact-form__form').length) {
    var wpcf7Elm = document.querySelector('.contact-form__form .wpcf7');
    wpcf7Elm.addEventListener('wpcf7mailsent', function (event) {
      $(this).siblings('.loader').toggle();
      $('.contact-form__form .wpcf7').toggle();
      var data = $('.contact-form__form .wpcf7 > form').serialize();

      if ($('.contact-form__form .wpcf7 .form-hidden').val() == 'general') {
        sendDetailsToPardot(data, 'contact-general', this);
      } else if ($('.contact-form__form .wpcf7 .form-hidden').val() == 'beneficiary') {
        sendDetailsToPardot(data, 'contact-beneficiary', this);
      }
    }, false);
  } // Gated content form


  if ($('.gated__content').length) {
    var wpcf7Elm = document.querySelector('.gated__content .wpcf7');
    wpcf7Elm.addEventListener('wpcf7mailsent', function (event) {
      $(this).siblings('.loader').toggle();
      $('.gated__content .wpcf7').toggle();
      var data = $('.gated__content .wpcf7 > form').serialize();
      sendDetailsToPardot(data, 'gated', this);
    }, false);
  } // Newsletter signup


  $('#newsletter').on('submit', function () {
    event.preventDefault();
    $(this).siblings('.loader').toggle();
    $('#newsletter').toggle();
    var data = $(this).serialize();
    sendDetailsToPardot(data, 'newsletter', this);
  }); // Homepage charity register banner

  var popup = $('.register-popup');
  var popupHeight = $('.register-popup h4').height() + 30;
  var popupSlider = $('.register-popup__slider');
  $('.register-popup').css('height', popupHeight);
  $('.register-popup__close').on('click', function () {
    $('.register-popup').slideToggle();
  });
  $('.register-popup__slider, .register-popup h4').on('click', function () {
    console.log('here');
    $('.register-popup__slider > .fa').toggle();
    var curHeight = popup.height();

    if ($(popupSlider).attr('data-state') == 'close') {
      openPopup(popup, curHeight);
      popupSlider.attr('data-state', 'open');
    } else {
      closePopup(popup, curHeight);
      popupSlider.attr('data-state', 'close');
    }
  });

  function openPopup(popup, curHeight) {
    $('.register-popup h4').toggle();
    var autoHeight = popup.css('height', 'auto').height();
    popup.height(curHeight).animate({
      height: autoHeight
    }, 750);
  }

  function closePopup(popup, curHeight) {
    popup.height(curHeight).animate({
      height: popupHeight
    }, 750, function () {
      $('.register-popup h4').toggle();
    });
  } // Send form submissions to Pardot


  function sendDetailsToPardot(data, type, form) {
    $.ajax({
      type: 'GET',
      url: ajax.ajax_url,
      data: {
        action: 'send_to_pardot',
        data: data,
        type: type
      },
      success: function success(response) {
        $(form).siblings('.loader').toggle();

        switch (type) {
          case 'newsletter':
            newsletterFormHandler(response);
            break;

          case 'gated':
            gatedFormHandler(response);
            break;

          case 'contact-general':
          case 'contact-beneficiary':
            contactFormHandler(response);
            break;

          default:
            break;
        }
      },
      error: function error(MLHttpRequest, response, errorThrown) {
        console.log('Error');
      }
    });
  } // Handles newsletter form after Pardot request


  function newsletterFormHandler(response) {
    if (response == '1') {
      $('.newsletter__success').toggle();
    } else {
      $('.newsletter__error').toggle();
    }
  } // Handles gated form after Pardot request


  function gatedFormHandler(response) {
    if (response == '1') {
      $('.gated__response--success').toggle();
    } else {
      $('.gated__response--error').toggle();
    }
  } // Handles contact form after Pardot request


  function contactFormHandler(response) {
    if (response == '1') {
      $('.contact-form__response--success').toggle();
    } else {
      $('.contact-form__response--error').toggle();
    }
  } // Select all links with hashes


  $('a[href*="#"]') // Remove links that don't actually link to anything
  .not('[href="#"]').not('[href="#0"]').click(function (event) {
    // On-page links
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']'); // Does a scroll target exist?

      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function () {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();

          if ($target.is(":focus")) {
            // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable

            $target.focus(); // Set focus again
          }

          ;
        });
      }
    }
  }); // Spread the word form

  if ($('.stw__form').length) {
    var wpcf7Elm = document.querySelector('.stw__form.wpcf7-form');
    wpcf7Elm.addEventListener('wpcf7mailsent', function (event) {
      $(this).toggle();
      var message = "\n                <div class=\"stw__form-response\">\n                    <h3>Thanks! An email has been sent to your friend.</h3>\n                    <p id=\"reload-stw\" class=\"btn btn--pink\">Invite another</p>\n                </div>\n            ";
      $(this).parent().append(message);
    }, false);
  }

  $('.wpcf7').on('click', '#reload-stw', function () {
    $('.stw__form-response').remove();
    $('.stw__form').toggle();
  });
  $('.view-toggle').on('click', function () {
    var toggler = $(this);
    var infoMore = toggler.siblings('.people__info-more');
    toggler.toggleClass('active');
    infoMore.toggleClass('active');

    if (toggler.hasClass('people__more')) {
      toggler.siblings('.people__less').toggleClass('active');
    } else {
      toggler.siblings('.people__more').toggleClass('active');
    }
  });
});